/// <amd-module name="TFS/Admin/OrganizationAadPolicyControls/Components/EditDisplayMessagePanel" />
import React = require("react");
import { IVssPageContext } from "VSS/Platform/Context";

import AdminResources = require("TFS/Admin/OrganizationAadPolicyControls/Resources");
import { IButtonProps } from "VSSUI/Button";
import { Panel } from "VSSUI/Panel";
import { ContentSize } from "VSSUI/Callout";
import { VssComponent } from "VSS/Platform/Layout";
import { ObservableValue } from "VSS/Core/Observable";
import { TextField, TextFieldWidth } from "VSSUI/TextField";
import { filterXSS } from "xss";
import { IEditDisplayMessagePanelComponentProps } from "TFS/Admin/OrganizationAadCommon/Contracts/AadPolicyControls.props";

export interface IEditDisplayMessagePanelComponentState {
    hasTextChanged: boolean;
    hasTextExceedLimit: boolean;
}

export class EditDisplayMessagePanelComponent extends React.Component<
    IEditDisplayMessagePanelComponentProps,
    IEditDisplayMessagePanelComponentState
> {
    private errorMessage = new ObservableValue<string>(this.props.displayErrorMessage);

    public constructor(props: IEditDisplayMessagePanelComponentProps) {
        super(props);

        this.state = {
            hasTextChanged: false,
            hasTextExceedLimit: false
        };
    }

    public render(): JSX.Element {
        const footerButtons: IButtonProps[] = [
            {
                onClick: this.props.onDismiss,
                text: AdminResources.CancelButton
            },
            {
                className: "primary-action-button",
                onClick: () => {
                    this.props.onUpdateErrorMessage(filterXSS(this.errorMessage.value));
                },
                disabled: !this.state.hasTextChanged,
                primary: true,
                text: AdminResources.SaveButton
            }
        ];

        return (
            <Panel
                onDismiss={this.props.onDismiss}
                titleProps={{ text: AdminResources.DisplayErrorMessageTitle }}
                size={ContentSize.Medium}
                footerButtonProps={footerButtons}
            >
                {this._renderPanelBody()}
            </Panel>
        );
    }

    private _renderPanelBody(): JSX.Element {
        return (
            <div className="width-100">
                <div>{AdminResources.Message}</div>
                <div className="edit-error-message-div width-100">
                    <TextField
                        ariaLabel={AdminResources.UpdateErrorMessage}
                        value={this.errorMessage}
                        onChange={this._onInputBoxTextChange}
                        multiline
                        rows={4}
                        width={TextFieldWidth.auto}
                    />
                </div>
                {this.state.hasTextExceedLimit === true && <div className="display-message-error-div">{AdminResources.MessageHasExceedLimit}</div>}
            </div>
        );
    }

    private _onInputBoxTextChange = (event: any, newValue: string) => {
        if (newValue !== this.props.displayErrorMessage) {
            if (newValue.length > 250) {
                this.setState({ hasTextExceedLimit: true });
            } else {
                this.errorMessage.value = newValue;
                this.setState({
                    hasTextChanged: true,
                    hasTextExceedLimit: false
                });
            }
        } else {
            this.setState({
                hasTextChanged: false,
                hasTextExceedLimit: false
            });
        }
    };
}

VssComponent.register("ms.vss-admin-web.aad-policy-error-message-panel", EditDisplayMessagePanelComponent);
